/**************************************************
 * Nombre:       Home_Oferta_Edutavita
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import CatalogoLista from "./SucComponentes/CatalogoLista";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import TextoTitulo from "./SucComponentes/TextoTitulo";

const Home_Oferta_Edutavita = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <TextoTitulo texto={'Nuestras Escuelas de Aprendizaje'} titulo={'OFERTA EDUCATIVA'}/>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <CatalogoLista/>
            </Grid>

        </Grid>
    )

}
export default Home_Oferta_Edutavita